<div class="container" [class.is-disabled]="!isEnabled" appDnd (fileDropped)="onFileDropped($event)"
    #popperError="popper" [popper]="tooltipErrTemplate"
    [popperDisabled]="!showErrorTooltip || !errorList || errorList?.length === 0"
    [popperTrigger]="ngxPopperjsTriggers.hover" popperApplyClass="error" [popperPlacement]="ngxPopperjsPlacements.TOP"
    [popperPreventOverflow]="false" [popperHideOnScroll]="true" popperAppendTo="body"
    [class.has-error]="showErrorBorder && errorList?.length > 0">

    <div *ngIf="pdfLoadedInViewer" class="signers-container">
        <div class="signer-name" *ngFor="let signer of layouts;let i=index;"
            [style.borderColor]="templateSignersColors[i]">
            {{signer.signerLabel.value}}
        </div>
    </div>

    <div class="pdf-container">
        <div class="pdf-actions" *ngIf="pdfLoadedInViewer">
            <nts-base-checkbox-text-box [(checkStatus)]="onlyPageWithSignatures" *ngIf="layouts?.length > 0"
                [labelText]="'Visualizza solo pagine con firma'"></nts-base-checkbox-text-box>
            <div style="display: flex; justify-content: center;">
                <nts-text-button [isDisabled]="!isEnabled || currentPage === 1" (onClicked)="prevPage()"
                    icon="arrow-back"></nts-text-button>
                <div class="pdf-current-status">{{ currentPage }} / {{ totalPages }}</div>
                <nts-text-button [isDisabled]="!isEnabled || currentPage === totalPages" (onClicked)="nextPage()"
                    icon="arrow-forward"></nts-text-button>
            </div>
        </div>
        <div class="pdf-viewer-container" [class.has-loader]="internalFile && !pdfLoadedInViewer">
            <pdf-viewer #pdfviewer *ngIf="currentFileData" (pageChange)="loadPageData($event)" [src]="currentFileData"
                [style.height.px]="initialWrapperHeight" [style.width.px]="initialWrapperWidth" [render-text]="false"
                [original-size]="false" (after-load-complete)="afterLoadComplete($event)" [show-all]="false"
                [page]="currentPage" [show-borders]="false" [fit-to-page]="false" zoom-scale="page-fit"></pdf-viewer>
            <nts-loader [skipHeader]="false" [animation]="true" *ngIf="internalFile && !pdfLoadedInViewer"
                [isVisible]="true"></nts-loader>
            <canvas #queryCanvas></canvas>
        </div>

    </div>

    <div class="drag-text-container" *ngIf="!pdfLoadedInViewer">
        <div class="action-drag" [class.full-screen]="!currentFileData">
            <input *ngIf="!internalFile" type="file" accept=".pdf" [attr.disabled]="isEnabled === false ? true : null"
                #fileDropRef id="fileDropRef" (change)="fileBrowseHandler($event)" />
            <span *ngIf="!internalFile" class="drag-text">{{'PdfPreview_AddFile_DisplayName' | NTSTranslate}}</span>
            <svg-icon *ngIf="!internalFile" class="drag-icon" fontSize="40px" key="submit-document"></svg-icon>
        </div>
    </div>

</div>
<div *ngIf="currentFileData" class="file-actions-container">
    <nts-text-button *ngIf="!uploadFileOnRemoteInProgress" (onClicked)="removeFile()" [icon]="'trash'" class="danger"
        [label]="'PdfPreview_Remove_DisplayName' | NTSTranslate"></nts-text-button>
    <div *ngIf="uploadFileOnRemoteInProgress" class="upload-file-in-progress">
        <svg-icon [fontSize]="'20px'" [key]="'refresh-animated'"></svg-icon>
        <div>Caricamento del PDF in corso....</div>
    </div>
</div>

<popper-content #tooltipErrTemplate>
    <ng-container *ngFor="let item of computedErrorList">
        {{ item }}
    </ng-container>
</popper-content>
